import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getPresetsRelation} from 'src/openapi/admin/apis/EntitlementsPresetApi';
import {useAppDispatch} from 'src/store/hooks';

import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';
import type {SuccessPayload} from 'src/typedef';

type Props = {
    presetId: string,
};

export const useEditRelations = ({presetId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(async () => {
        const response = await apiDispatch(getPresetsRelation({presetIds: [presetId]}));

        if (response.payload.success) {
            const payload: {success: true, error: false, data: PresetRelationItem[]} = {
                success: true,
                error: false,
                data: response.payload.data[presetId],
            };

            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: response.payload});
        }
    }, [presetId, apiDispatch]);

    const saveDispatchAction = useCallback(() => {
        const payload: SuccessPayload<undefined> = {
            success: true,
            error: false,
            data: undefined,
        };

        return Promise.resolve({type: '', payload});
    }, []);

    return useCommonDataHook({
        initValue: [],
        getDispatchAction,
        saveDispatchAction,
    });
};
